module.exports = __webpack_public_path__ + "static/img/video.62edf6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video.png
// module id = wa1j
// module chunks = 1